import React, {Component} from 'react';
import {connect} from 'react-redux';
import {resources, scopes} from '../../common/permissions/dictionary';
import {hasAccessPermission} from '../../common/permissions/validations';
import {paths} from '../../common/dictionaries/urls';
import Spread from './spread/index';
import './vehicleSaleForecast.scss';
import {Actions} from '../../common/actions';


class VehicleForecast extends Component {
  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.VehicleSaleForecast, scopes.Create) &&
      !hasAccessPermission(this.props.permissions, resources.VehicleSaleForecastExonerated, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  render() {
    const {salesType} = this.props;
    return (
      <div className='veh-sale-forecast'>
        <Spread salesType={salesType}></Spread>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'salesType': ownProps.params && ownProps.params.salesType,
    'permissions': state.session.permissions,
  };
};

const {
  withRouter,
} = Actions;


export default withRouter(connect(mapStateToProps, {
})(VehicleForecast));
